<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4 7.74797V23C4 24.6569 5.34315 26 7 26H25C26.6569 26 28 24.6569 28 23V12.252C28 10.5952 26.6569 9.25203 25 9.25203H5.62602C4.72799 9.25203 4 8.52404 4 7.62602V7.62602C4 6.72799 4.72799 6 5.62602 6H19.7604C21.4173 6 22.7604 7.34315 22.7604 9V9.15549"
        stroke="var(--icon-color)" stroke-width="2" />
    <rect x="4" y="10" width="23" height="15" fill="var(--icon-color)" />
    <rect x="7" y="14" width="4" height="2" rx="1" fill="var--bg-color)" />
    <rect x="7" y="17" width="4" height="2" rx="1" fill="var(--bg-color)" />
    <rect x="7" y="20" width="4" height="2" rx="1" fill="var(--bg-color)" />
    <rect x="14" y="14" width="4" height="2" rx="1" fill="var(--bg-color)" />
    <rect x="14" y="17" width="4" height="2" rx="1" fill="var(--bg-color)" />
    <rect x="14" y="20" width="4" height="2" rx="1" fill="var(--bg-color)" />
    <rect x="21" y="14" width="4" height="2" rx="1" fill="var(--bg-color)" />
    <rect x="21" y="17" width="4" height="2" rx="1" fill="var(--bg-color)" />
    <rect x="21" y="20" width="4" height="2" rx="1" fill="var(--bg-color)" />
</svg>

